export default function EMVendorsController() {
  const vm = this;

  vm.handleAddedVendor = _handleAddedVendor;
  vm.handleDeletedVendor = _handleDeletedVendor;

  // //////// METHODS //////////

  function _handleAddedVendor(vendor) {
    vm.vendors.splice(vm.vendors.indexOf(vendor), 1);
  }

  function _handleDeletedVendor(vendor) {
    vm.vendors.splice(vm.vendors.indexOf(vendor), 1);
  }
}

EMVendorsController.$inject = [];
